document.addEventListener('DOMContentLoaded', () => {
  // Initialize Masonry
  const grid = document.getElementById('grid-realisations');
  const masonry = new Masonry(grid, {
    itemSelector: '.grid-realisations__item',
    columnWidth: '.grid-realisations__item',
    gutter: 20, // Adjust as needed
  });

  // Refresh Masonry layout after images are loaded (optional)
  imagesLoaded(grid).on('progress', () => {
    masonry.layout();
  });
});
